export default __webpack_public_path__ + "static/media/line-pattern.c52a7cf1.svg";